// extracted by mini-css-extract-plugin
module.exports = {"Unicorn_profileWrapper":"style_Unicorn_profileWrapper__eQLwX","Pegasus_profileWrapper":"style_Pegasus_profileWrapper__PbtNg"};